import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Header from "./global/Header";
import DataHeader from "./global/DataHeader";
import Footer from "./global/Footer";
import { ReactComponent as GroupLogo } from "./data/svg/6334.svg";
import { ReactComponent as AnalyticsLogo } from "./data/svg/6A.svg";
import { ReactComponent as AcademyLogo } from "./data/svg/6334Academy.svg";
import GroupHome from "./pages/group/Home";
import GroupAbout from "./pages/group/About";
import GroupServices from "./pages/group/Services";
import GroupTeam from "./pages/group/Team";
import GroupContact from "./pages/group/Contact";
import AcademyHome from "./pages/academy/Home";
import AnalyticsHome from "./pages/analytics/Home";
import AnalyticsReports from "./pages/analytics/Reports";
import AnalyticsMaps from "./pages/analytics/Maps";
import AnalyticsDownloads from "./pages/analytics/Downloads";
import AnalyticsPublications from "./pages/analytics/Publications";
import { menuItems } from "./data/database";
import "../src/styles/index.css";

const mainLinkLogo = [
  {
    label: "Academy",
    LinkLogoSvg: AcademyLogo,
    link: "/academy",
  },
  {
    label: "Analytics",
    LinkLogoSvg: AnalyticsLogo,
    link: "/analytics",
  },
];

const analyticsLinkLogo = [
  { label: "6334", LinkLogoSvg: GroupLogo, link: "/" },
  {
    label: "Academy",
    LinkLogoSvg: AcademyLogo,
    link: "/academy",
  },
];

const GroupLayout = () => (
  <Box>
    <Outlet />
    <Header LogoSvg={GroupLogo} menuItems={menuItems} linkLogo={mainLinkLogo} />
    <Footer />
  </Box>
);

const AnalyticsLayout = () => (
  <Box>
    <Outlet />
    <DataHeader
      LogoSvg={GroupLogo}
      menuItems={menuItems}
      linkLogo={analyticsLinkLogo}
    />
    <Footer />
  </Box>
);

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        {/* MAIN WEBSITE */}
        <Routes>
          {/* <Route path="/" element={<GroupHome />} /> */}
          <Route path="/" element={<GroupLayout />}>
            {/* Home */}
            <Route index element={<GroupHome />} />

            {/* About */}
            <Route path="/about" element={<GroupAbout />} />

            {/* Services */}
            <Route path="/services" element={<GroupServices />} />

            {/* Team */}
            <Route path="/team" element={<GroupTeam />} />

            {/* Contact */}
            <Route path="/contact" element={<GroupContact />} />
          </Route>

          {/* ACADEMY WEBSITE */}
          <Route path="/academy" element={<AcademyHome />} />

          {/* ANALYTICS WEBSITE */}
          <Route path="/analytics" element={<AnalyticsLayout />}>
            {/* Home */}
            <Route index element={<AnalyticsHome />} />

            {/* Reports */}
            <Route path="/analytics/reports" element={<AnalyticsReports />} />

            {/* Maps */}
            <Route path="/analytics/maps" element={<AnalyticsMaps />} />

            {/* Downloads */}
            <Route
              path="/analytics/downloads"
              element={<AnalyticsDownloads />}
            />
            {/* Publications */}
            <Route
              path="/analytics/publications"
              element={<AnalyticsPublications />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
